export const getVersionFilters = (versions?: string[]) =>
    versions?.map((version) => ({
        key: version,
        label: version,
        name: version
    })) || [];
